<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <!-- Settings Menu -->
          <leads-tabs></leads-tabs>
          <!-- /Settings Menu -->

          <div class="row">
            <organization-update-sidebar></organization-update-sidebar>

            <div class="col-xl-9 col-lg-12">
              <!-- Info -->
              <div class="card">
                <div class="card-body">
                  <div v-if="loading" class="loader">Loading...</div>
                  <form v-else @submit.prevent="submitForm">
                    <div class="border-bottom mb-3">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">
                              Organization Name
                              <span class="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              v-model="organizationName"
                              class="form-control"
                            />
                            <div
                              class="text-danger"
                              v-if="errors.organization_name"
                            >
                              {{ errors.organization_name[0] }}
                            </div>
                          </div>
                        </div>
                        <!-- <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">Industry Type</label>
                            <multiselect
                              v-model="industryType"
                              :options="industryTypes"
                              track-by="id"
                              label="type"
                              placeholder="Select Industry"
                            >
                            </multiselect>
                          </div>
                        </div> -->
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label">Industry Type</label>
                            <input
                              type="text"
                              v-model="industryType"
                              @input="handleIndustryTypeInput"
                              placeholder="Type to search..."
                              class="form-control"
                            />
                            <div
                              v-if="filteredIndustryTypes.length > 0"
                              class="dropdown-box"
                            >
                              <ul>
                                <li
                                  v-for="item in filteredIndustryTypes"
                                  :key="item.id"
                                  @click="selectIndustryTypeItem(item)"
                                >
                                  {{ item.type }}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label"
                              >Information Source</label
                            >
                            <input
                              type="text"
                              v-model="informationSourceQuery"
                              @input="handleInput"
                              placeholder="Type to search..."
                              class="form-control"
                            />
                            <div
                              v-if="filteredInfoSources.length > 0"
                              class="dropdown-box"
                            >
                              <ul>
                                <li
                                  v-for="item in filteredInfoSources"
                                  :key="item.id"
                                  @click="selectInfoSourceItem(item)"
                                >
                                  {{ item.name }}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">
                              Phone <span class="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              v-model="phone"
                              class="form-control"
                            />
                            <div class="text-danger" v-if="errors.phone">
                              {{ errors.phone[0] }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label"> Address </label>
                            <input
                              type="text"
                              v-model="address"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label">
                              Select Leads Priority
                              <span class="text-danger">*</span>
                            </label>
                            <multiselect
                              v-model="priority"
                              :options="priorities"
                              track-by="name"
                              label="name"
                            >
                            </multiselect>
                            <div
                              class="text-danger"
                              v-if="errors.lead_priority"
                            >
                              {{ errors.lead_priority[0] }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label">
                              Select Country <span class="text-danger">*</span>
                            </label>
                            <multiselect
                              v-model="countryID"
                              :options="countries"
                              track-by="id"
                              label="name"
                            >
                            </multiselect>
                            <div class="text-danger" v-if="errors.country_id">
                              {{ errors.country_id[0] }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">Select Divisions</label>
                            <multiselect
                              v-model="divisionID"
                              :options="divisions"
                              track-by="id"
                              label="name"
                            >
                            </multiselect>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">Select District</label>
                            <multiselect
                              v-model="districtID"
                              :options="districts"
                              track-by="id"
                              label="name"
                            >
                            </multiselect>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label"
                              >Select Area/Zone</label
                            >
                            <multiselect
                              v-model="zoneID"
                              :options="zones"
                              track-by="id"
                              label="name"
                            >
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">Website </label>
                            <input
                              type="text"
                              v-model="websiteLink"
                              class="form-control"
                            />
                            <div class="text-danger" v-if="errors.website_link">
                              {{ errors.website_link[0] }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div
                          v-for="(exhibition, index) in exhibitions"
                          :key="index"
                          class="col-md-12"
                        >
                          <div
                            class="card"
                            style="margin-bottom: unset !important"
                          >
                            <div class="card-header additional-header">
                              <div class="header-index">
                                Exhibition {{ index + 1 }}
                              </div>
                              <div>
                                <button
                                  v-if="exhibitions.length > 1"
                                  class="btn btn-danger btn-sm"
                                  type="button"
                                  @click="removeExhibition(index)"
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                            <div class="card-body">
                              <div class="">
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="mb-3">
                                      <label class="form-label">
                                        Exhibition
                                        <span class="text-danger">*</span>
                                      </label>
                                      <multiselect
                                        v-model="exhibition.exhibition_id"
                                        :options="projects"
                                        track-by="id"
                                        label="name"
                                        placeholder="Select Exhibition"
                                      >
                                      </multiselect>
                                      <div
                                        class="text-danger"
                                        v-if="
                                          errors[
                                            `exhibitions.${index}.exhibition_id`
                                          ]
                                        "
                                      >
                                        {{
                                          errors[
                                            `exhibitions.${index}.exhibition_id`
                                          ][0]
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <label class="form-label">
                                      Assign To
                                      <span class="text-danger">*</span>
                                    </label>
                                    <multiselect
                                      v-model="exhibition.employee_id"
                                      :options="employees"
                                      track-by="id"
                                      label="name"
                                      placeholder="Select Employee"
                                    >
                                    </multiselect>
                                    <div
                                      class="text-danger"
                                      v-if="
                                        errors[
                                          `exhibitions.${index}.employee_id`
                                        ]
                                      "
                                    >
                                      {{
                                        errors[
                                          `exhibitions.${index}.employee_id`
                                        ][0]
                                      }}
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <label class="form-label">
                                      Additional Assign To
                                    </label>
                                    <multiselect
                                      v-model="exhibition.additionalEmployeeID"
                                      :options="employees"
                                      track-by="id"
                                      label="name"
                                      placeholder="Select Additional Assign To"
                                    >
                                    </multiselect>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        class="btn btn-primary btn-sm mb-2"
                        type="button"
                        @click="addExhibition"
                      >
                        Add New <i class="fas fa-plus icon-spacing"></i>
                      </button>
                      <div class="row">
                        <div
                          v-for="(social, index) in socialNetworks"
                          :key="index"
                          class="col-md-12"
                        >
                          <div
                            class="card"
                            style="margin-bottom: unset !important"
                          >
                            <div class="card-header additional-header">
                              <div>Social Network {{ index + 1 }}</div>
                              <div>
                                <button
                                  v-if="socialNetworks.length > 1"
                                  class="btn btn-danger btn-sm"
                                  type="button"
                                  @click="removeSocialNetwork(index)"
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                            <div class="card-body">
                              <div class="">
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="form-label">
                                        Social Media
                                      </label>
                                      <multiselect
                                        v-model="social.mediaName"
                                        :options="socialMedias"
                                        track-by="name"
                                        label="name"
                                        placeholder="Select Social Media"
                                      >
                                      </multiselect>
                                      <div
                                        class="text-danger"
                                        v-if="
                                          errors[
                                            `social_networks.${index}.mediaName`
                                          ]
                                        "
                                      >
                                        {{
                                          errors[
                                            `social_networks.${index}.mediaName`
                                          ][0]
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <label class="form-label"> URL </label>
                                    <input
                                      type="text"
                                      v-model="social.URL"
                                      class="form-control"
                                    />
                                    <div
                                      class="text-danger"
                                      v-if="
                                        errors[`social_networks.${index}.URL`]
                                      "
                                    >
                                      {{
                                        errors[
                                          `social_networks.${index}.URL`
                                        ][0]
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        class="btn btn-primary btn-sm mb-2"
                        type="button"
                        @click="addSocialNetworks"
                      >
                        Add New <i class="fas fa-plus icon-spacing"></i>
                      </button>
                    </div>

                    <div class="btn-list">
                      <button
                        style="float: right"
                        type="submit"
                        :disabled="isLoading"
                        class="btn btn-success"
                      >
                        Next
                        <span
                          v-if="isLoading"
                          class="spinner-border spinner-border-sm ms-2"
                        ></span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /Info -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import http from "@/utils/http";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      title: "Initial Information",
      initialID: "",

      organizationName: "",
      industryTypes: [],
      filteredIndustryTypes: [],
      industryType: "",
      industryTypeId: "",

      informationSources: [],
      filteredInfoSources: [],
      informationSourceQuery: "",
      informationSourceId: "",
      debounceTimeout: null,

      phone: "",
      address: "",

      priorities: [
        { name: "Very Good" },
        { name: "Good" },
        { name: "Low" },
        { name: "Very Low" },
      ],
      priority: null,

      countries: [],
      countryID: "",
      divisions: [],
      divisionID: "",
      districts: [],
      districtID: "",
      zones: [],
      zoneID: "",

      websiteLink: "",

      exhibitions: [
        { exhibition_id: "", employee_id: "", additionalEmployeeID: "" },
      ],
      employees: [],
      projects: [],

      socialNetworks: [{ mediaName: "", URL: "" }],
      socialMedias: [
        { id: 1, name: "Facebook" },
        { id: 2, name: "Instagram" },
        { id: 3, name: "Twiter" },
        { id: 4, name: "linkedin" },
      ],
      errors: {},
      leadId: null,
    };
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler(newId) {
        this.leadId = newId;
      },
    },
    countryID(newValue) {
      if (newValue) {
        this.getDivisionsByCountry();
      }
    },
    divisionID(newValue) {
      if (newValue) {
        this.getDistrictsByDivision();
      }
    },
    districtID(newValue) {
      if (newValue) {
        this.getZonesByDistrict();
      }
    },
  },
  mounted() {
    this.getLeadInfo();
  },
  methods: {
    async getLeadInfo() {
      this.loading = true;
      const endpoint = `/leads/${this.leadId}`;
      const method = "get";
      try {
        const response = await http[method](endpoint);

        this.initialID = response.data.contents.initial_info.id;
        this.organizationName =
          response.data.contents.initial_info.organization_name;

        // this.industryType = response.data.contents.initial_info?.industry_type;

        this.industryType = response.data.contents.initial_info?.industry
          ? response.data.contents.initial_info?.industry?.type
          : "";

        this.informationSourceQuery = response.data.contents.initial_info
          ?.information_source
          ? response.data.contents.initial_info?.information_source?.name
          : "";
        // this.informationSourceId =
        //   response.data.contents.initial_info?.information_source?.id;
        this.phone = response.data.contents.initial_info?.phone;
        this.address = response.data.contents.initial_info?.address;
        this.priority = response.data.contents.lead_priority;
        this.countryID = response.data.contents.initial_info.country.id;
        this.divisionID =
          response.data.contents.initial_info?.country?.division?.id;
        this.districtID =
          response.data.contents.initial_info?.zone?.district?.id;
        this.zoneID = response.data.contents.initial_info?.zone_id;
        this.websiteLink = response.data.contents.initial_info.website_link;
        this.exhibitions = response.data.contents.initial_info.exhibitions;
        this.socialNetworks =
          response.data.contents.initial_info.social_networks;

        setTimeout(() => {
          if (this.priority != "") {
            const foundPriority = this.priorities.find(
              (data) => data.name == this.priority
            );
            if (foundPriority) {
              this.priority = foundPriority;
            }
          }
        });
        await Promise.all([
          this.getIndustryTypes(),
          this.getInformationSource(),
          this.getCountries(),
          this.getEmployees(),
          this.getExhibitions(),
        ]);
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },

    async getIndustryTypes() {
      try {
        const response = await http.get("industries");
        this.industryTypes = response.data.contents;
        if (this.industryType != "") {
          // const foundIndustry = response.data.contents.find(
          //   (data) => data.id == this.industryType
          // );
          // if (foundIndustry) {
          //   this.industryType = foundIndustry;
          // }
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },

    async getExhibitions() {
      const endpoint = `/exhibitions`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.projects = response.data.contents;
      } catch (error) {
        //
      }
    },
    async getEmployees() {
      const endpoint = `/employees`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.employees = response.data.contents.map((employee) => {
          return {
            id: employee.id,
            name: employee?.user?.name,
          };
        });
      } catch (error) {
        //
      }
    },
    async getCountries() {
      const endpoint = `/countries`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.countries = response.data.contents;
        if (this.countryID != "") {
          const foundCountry = response.data.contents.find(
            (data) => data.id == this.countryID
          );
          if (foundCountry) {
            this.countryID = foundCountry;
          }
        }
      } catch (error) {
        //
      }
    },
    async getDivisionsByCountry() {
      this.divisions = [];
      const endpoint = `/divisions-by-country`;
      const method = "post";
      let body = {
        country_id: this.countryID.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.divisions = response.data.contents;
        if (this.divisionID != "") {
          const foundDivision = this.divisions.find(
            (data) => data.id == this.divisionID
          );
          if (foundDivision) {
            this.divisionID = foundDivision;
          }
        }
      } catch (error) {
        //
      }
    },

    async getDistrictsByDivision() {
      this.districts = [];
      const endpoint = `/districts-by-division`;
      const method = "post";
      let body = {
        division_id: this.divisionID.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.districts = response.data.contents;
        if (this.districtID != "") {
          const foundDistrict = this.districts.find(
            (data) => data.id == this.districtID
          );
          if (foundDistrict) {
            this.districtID = foundDistrict;
          }
        }
      } catch (error) {
        //
      }
    },

    async getZonesByDistrict() {
      this.districts = [];
      const endpoint = `/zones-by-district`;
      const method = "post";
      let body = {
        district_id: this.districtID.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.zones = response.data.contents;
        if (this.zoneID != "") {
          const foundZone = this.zones.find((data) => data.id == this.zoneID);
          if (foundZone) {
            this.zoneID = foundZone;
          }
        }
      } catch (error) {
        //
      }
    },

    handleInput() {
      if (this.informationSourceQuery.length > 2) {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
          this.fetchResults();
        }, 300);
      } else {
        this.filteredInfoSources = [];
      }
    },

    handleIndustryTypeInput() {
      if (this.industryType.length > 2) {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
          this.fetchIndustryTypeResults();
        }, 300);
      } else {
        this.filteredIndustryTypes = [];
      }
    },

    fetchResults() {
      const query = this.informationSourceQuery.toLowerCase();
      this.filteredInfoSources = this.informationSources.filter((source) =>
        source.name.toLowerCase().includes(query)
      );
    },

    fetchIndustryTypeResults() {
      const query = this.industryType.toLowerCase();
      this.filteredIndustryTypes = this.industryTypes.filter((industry) =>
        industry.type.toLowerCase().includes(query)
      );
    },

    async getInformationSource() {
      try {
        const response = await http["post"]("get-information-sources", {
          // search: this.informationSourceQuery
        });
        this.informationSources = response.data.contents;
        // this.filteredInfoSources = [...this.informationSources];
        // if(this.informationSourceId != ''){
        //   const foundData = response.data.contents.find((data) => data.id == this.informationSourceId)
        //   if(foundData){
        //     this.informationSourceQuery = foundData.name
        //   }
        // }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    selectInfoSourceItem(item) {
      this.informationSourceQuery = item.name;
      this.informationSourceId = item.id;
      this.filteredInfoSources = [];
    },

    selectIndustryTypeItem(item) {
      this.industryType = item.type;
      this.industryTypeId = item.id;
      this.filteredIndustryTypes = [];
    },

    addExhibition() {
      this.exhibitions.push({
        exhibition_id: "",
        employee_id: "",
        additionalEmployeeID: "",
      });
    },

    removeExhibition(index) {
      this.exhibitions.splice(index, 1);
    },

    addSocialNetworks() {
      this.socialNetworks.push({
        mediaName: "",
        URL: "",
      });
    },

    removeSocialNetwork(index) {
      this.socialNetworks.splice(index, 1);
    },

    async submitForm() {
      this.isLoading = true;
      const endpoint = "/update-leads-initial-info";
      const method = "post";
      let body = {
        initialID: this.initialID,
        organization_name: this.organizationName,
        // industry_type: this.industryType ? this.industryType.id : '',
        industry_type_text: this.industryType,
        industry_type_id: this.industryTypeId,
        information_source_id: this.informationSourceId,
        information_source_text: this.informationSourceQuery,
        phone: this.phone,
        address: this.address,
        lead_priority: this.priority?.name,
        zone_id: this.zoneID ? this.zoneID.id : "",
        country_id: this.countryID.id,
        website_link: this.websiteLink,
        exhibitions: this.exhibitions,
        social_networks: this.socialNetworks,
      };
      try {
        const response = await http[method](endpoint, body);

        this.$toast.success(response.data.message);
        this.$router.push(
          `/leads-organization/${this.leadId}/concern-person-info`
        );
      } catch (error) {
        this.errors = error.response?.data?.errors || {};
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred. Please try again.";
        this.$toast.error(errorMessage);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style scoped>
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1000;
  font-size: 20px;
  font-weight: bold;
}

.dropdown-box {
  position: relative;
  border: 1px solid #ddd;
  max-height: 150px;
  overflow-y: auto;
  background: #fff;
  margin-top: 5px;
}

.dropdown-box ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.dropdown-box li {
  padding: 10px;
  cursor: pointer;
  transition: background 0.3s;
}

.dropdown-box li:hover {
  background: #f0f0f0;
}
</style>
